// extracted by mini-css-extract-plugin
export default {"cartBtn":"cart_cartBtn__cXDQD","cartWalletBtn":"cart_cartWalletBtn__ZI28g","cartCount":"cart_cartCount__+2cTE"};